import { BaseReportTrigger, Report } from '@/feature/reports/types/Report'

import { useNetworkMutation } from '@/lib/utils/request'
export type ReplayReportTrigger = BaseReportTrigger & {
  assetId: number
}

export const useReplayReportRequest = () =>
  useNetworkMutation<Report, ReplayReportTrigger>({
    url: `/v1/reports/replay/`,
    method: 'post',
  })
